// extracted by mini-css-extract-plugin
export default {"gallery-ctas":"gallery-ctas--mp-aAupx","galleryCtas":"gallery-ctas--mp-aAupx","gallery-ctas-text":"gallery-ctas-text--mp-I7DL5","galleryCtasText":"gallery-ctas-text--mp-I7DL5"};